import React from 'react';
import {Text, Heading, Box, StatusBar} from 'native-base';
import {SafeAreaView} from 'react-native-safe-area-context';
import {message} from './../../../utils/messages';
import {ImageBackground, StyleSheet} from 'react-native';
import {GoBackButton} from '../../buttons';
import {IBackButton} from '../../../interfaces/ui';

interface Props {
  title: string;
  summary: string;
  children: JSX.Element[] | JSX.Element;
  backButton?: IBackButton;
}

const imageSource = require('./background.png');

const ExternalTemplate = (props: Props) => {
  const {children, title, summary, backButton} = props;

  const handleBack = () => {
    if (backButton) {
      backButton.onPress();
    }
  };

  return (
    <SafeAreaView style={styles.safeAreaView} edges={['top']}>
      <StatusBar
        translucent
        backgroundColor="transparent"
        barStyle="light-content"
      />
      <Box flex="1">
        <ImageBackground
          style={styles.background}
          imageStyle={styles.backgroundImage}
          source={imageSource}>
          {backButton ? (
            <GoBackButton
              label={backButton.label}
              usage="external"
              onPress={() => handleBack()}
              mt="5"
            />
          ) : (
            <Box height="10" width="100%" mt="5" />
          )}
          <Heading color={'white'} marginX="5" paddingBottom="0" size="lg">
            {message(title)}
          </Heading>
          <Text color={'white'} marginX="5">
            {message(summary)}
          </Text>
        </ImageBackground>

        <Box
          backgroundColor="white"
          flex="1"
          borderTopRadius="20"
          paddingTop="5"
          paddingX={8}>
          {children}
        </Box>
      </Box>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  background: {
    width: '100%',
    paddingBottom: '4%',
    height: 120,
  },
  safeAreaView: {
    backgroundColor: '#06355e',
    flex: 1,
  },
  backgroundImage: {
    height: 130,
    marginTop: 10,
    alignSelf: 'flex-end',
    resizeMode: 'cover',
    position: 'absolute',
    right: 0,
  },
});

export default ExternalTemplate;
